// recon-bank-finish-messages translations (English catalog).
window.PlummeI18n.register('en', {
  'rcb.finish.assertFailed': 'The bank statement cannot be reconciled yet.',
  'rcb.finish.archiveRejected': 'The archiving was rejected.',
  'rcb.finish.unhandledLines': 'Cannot archive yet: {count} bank line(s) not fully handled{label}{status}.',
  'rcb.finish.balanceDeviation': 'Cannot archive yet: the balance difference is {deviation} kr.',
  'rcb.finish.failed': 'Could not reconcile the bank statement.',
});
